module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h7a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H4V4h24v24h-5a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h7c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zM16.646 12.356c-.356-.47-.936-.478-1.292-.008L10.18 19c-.358.472-.164 1 .43 1H14v11c0 .55.448 1 1 1h2c.552 0 1-.45 1-1V20h3.39c.594 0 .788-.53.43-1l-5.174-6.644z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/move-up-1.js
// module id = 1291
// module chunks = 14